<template>
  <div>
    <el-drawer
      title="下单量预约"
      :visible.sync="show"
      size="960px"
      append-to-body
      :wrapper-closable="false"
      custom-class="order-reserve-drawer"
    >
    <div class="drawer-body" v-if="product">
      <div class="drawer-left">
        <div class="product-preview">
          <div class="product-image">
            <el-image
              v-if="productImage"
              class="image"
              :src="productImage"
              fit="cover"
            />
            <img v-else src="../../../../../assets/images/default.png" class="image" />
          </div>
          <div class="product-title">{{ productName }}</div>
        </div>
      </div>

      <div class="drawer-right">
        <div class="form-section-title">约量信息提交</div>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          :validate-on-rule-change="false"
          label-width="120px"
          size="small"
        >
          <el-form-item label="下单路径" prop="salesPathCode">
            <el-select v-model="form.salesPathCode" placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="item in salesPathOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="所需库存" prop="reservationType">
            <el-radio-group v-model="form.reservationType">
              <el-radio :label="RESERVATION_TYPE.QUANTITY">按数量预约</el-radio>
              <el-radio :label="RESERVATION_TYPE.GMV">按GMV预约</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            :label="form.reservationType === RESERVATION_TYPE.GMV ? '下单金额' : '下单数量'"
            prop="reservationAmount"
          >
            <el-input
              v-model="form.reservationAmount"
              :placeholder="form.reservationType === RESERVATION_TYPE.GMV ? '请输入下单金额' : '请输入下单数量'"
            >
              <template slot="append">{{ form.reservationType === RESERVATION_TYPE.GMV ? '元' : '件' }}</template>
            </el-input>
          </el-form-item>

          <el-form-item label="佣金" prop="commissionType">
            <el-radio-group v-model="form.commissionType">
              <el-radio :label="COMMISSION_TYPE.RATE">佣金比例</el-radio>
              <el-radio :label="COMMISSION_TYPE.FIXED">固定佣金</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            :label="form.commissionType === COMMISSION_TYPE.RATE ? '佣金比例' : '佣金金额'"
            prop="commissionValue"
          >
            <el-input
              v-model="form.commissionValue"
              :placeholder="form.commissionType === COMMISSION_TYPE.RATE ? '请输入佣金比例' : '请输入佣金金额'"
            >
              <template slot="append">{{ form.commissionType === COMMISSION_TYPE.RATE ? '%' : '元/件' }}</template>
            </el-input>
          </el-form-item>

          <el-form-item label="预期下单时间" prop="expectedOrderTime">
            <el-date-picker
              v-model="form.expectedOrderTime"
              type="datetime"
              placeholder="请选择预期下单时间"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="expectedOrderPickerOptions"
              @change="handleExpectedOrderTimeChange"
            />
          </el-form-item>

          <!-- <el-form-item label="备注">
            <el-input
              v-model="form.remark"
              type="textarea"
              :rows="3"
              maxlength="260"
              show-word-limit
              placeholder="请输入备注信息"
            />
          </el-form-item> -->
        </el-form>
      </div>
    </div>

      <div class="drawer-footer">
        <el-button @click="show = false">返回</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">提交</el-button>
      </div>
    </el-drawer>

    <VolumeSubmitSuccessDialog
      ref="successDialogRef"
      :qr-code-url="qrCodeUrl"
    />
  </div>
</template>

<script>
import {
  submitQdVolume,
  getSupVolumeBindQRCode,
  buildWechatQrCodeUrl
} from '@/service/apis/supVolume'
import { getUserId } from '@/utils/getUser'
import VolumeSubmitSuccessDialog from '@/page/component/sections/xpk/sup/volume-submit-success-dialog'
import {
  RESERVATION_TYPE,
  COMMISSION_TYPE,
  getProductFullName,
  buildQdSubmitPayload,
  loadSalesPathOptions,
  getDefaultVolumeForm,
  getVolumeFormRules,
  getExpectedOrderPickerOptions,
  validateVolumeForm
} from '@/page/component/sections/xpk/sup/sup-volume-fields'

export default {
  name: 'OrderReserveDrawer',
  components: {
    VolumeSubmitSuccessDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      RESERVATION_TYPE,
      COMMISSION_TYPE,
      salesPathOptions: [],
      submitLoading: false,
      qrCodeUrl: '',
      qrCodeFetching: false,
      form: getDefaultVolumeForm(),
      rules: getVolumeFormRules()
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    productName() {
      return getProductFullName(this.product)
    },
    productImage() {
      return this.product.productImage || this.product.productMainImage || ''
    },
    expectedOrderPickerOptions() {
      return getExpectedOrderPickerOptions(this.form.expectedOrderTime)
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.initDrawer()
      }
    },
    'form.reservationType'() {
      this.form.reservationAmount = ''
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate(['reservationAmount'])
      })
    },
    'form.commissionType'() {
      this.form.commissionValue = ''
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate(['commissionValue'])
      })
    }
  },
  methods: {
    handleExpectedOrderTimeChange() {
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.validateField('expectedOrderTime')
      })
    },
    async initDrawer() {
      this.form = getDefaultVolumeForm()
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
      this.fetchQrCode()
      await this.loadSalesPathOptions()
    },
    fetchQrCode() {
      if (this.qrCodeUrl || this.qrCodeFetching) return

      const accountId = getUserId()
      if (!accountId) return

      this.qrCodeFetching = true
      getSupVolumeBindQRCode.call(this, { accountId }).then(res => {
        if (res && res.ticket) {
          this.qrCodeUrl = buildWechatQrCodeUrl(res.ticket)
        }
      }).finally(() => {
        this.qrCodeFetching = false
      })
    },
    loadSalesPathOptions() {
      return loadSalesPathOptions(this).then(list => {
        this.salesPathOptions = list
      })
    },
    async handleSubmit() {
      const valid = await validateVolumeForm(this.$refs.formRef, this)
      if (!valid) return

      const payload = buildQdSubmitPayload({
        product: this.product,
        form: this.form,
        salesPathOptions: this.salesPathOptions
      })

      this.submitLoading = true
      submitQdVolume.call(this, payload).then(() => {
        this.$emit('success')
        this.show = false
        this.$nextTick(() => {
          this.$refs.successDialogRef && this.$refs.successDialogRef.show()
        })
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>
.drawer-body {
  display: flex;
  height: calc(100vh - 140px);
  padding: 0 20px;
  overflow: hidden;
}

.drawer-left {
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #eee;
  padding-right: 20px;
  overflow: hidden;
}

.product-preview {
  flex-shrink: 0;
}

.product-image {
  position: relative;
  width: 100%;
  padding-top: 100%;
  background-color: #f5f5f5;
  border-radius: 2px;
  overflow: hidden;
}

.product-image .image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-image .image ::v-deep .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-title {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #333;
  text-align: center;
}

.drawer-right {
  flex: 1;
  padding-left: 24px;
  overflow-y: auto;
}

.form-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 16px 0;
}

.drawer-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: auto;
  padding: 12px 24px;
  border-top: 1px solid #eee;
  background-color: #fff;
}

.drawer-footer ::v-deep .el-button {
  height: 32px;
  padding: 0 15px;
  line-height: 32px;
}

.drawer-footer .el-button + .el-button {
  margin-left: 12px;
}
</style>

<style>
.order-reserve-drawer .el-drawer__body {
  position: relative;
  padding-bottom: 60px;
}
</style>
